import Image from 'next/image';

type TestimonialCardProps = {
  cabinet: string;
  client: string;
  description: string;
  logo: string;
  reverse?: boolean;
};

export default function TestimonialCard({
  cabinet,
  client,
  description,
  logo,
  reverse = false,
}: TestimonialCardProps) {
  return (
    <article
      className={`border-dark-blue/[0.07] w-[300px] shrink-0 rounded-(--radius-current) border bg-white p-6 md:w-[360px] md:p-8 ${
        reverse ? '-scale-x-100' : ''
      }`}
    >
      <Image
        alt={`logo ${cabinet}`}
        className="mb-5 h-8 w-auto"
        height={40}
        loading="lazy"
        src={logo}
        width={120}
      />

      <span
        aria-hidden="true"
        className="text-orange/20 mb-2 block font-serif text-5xl leading-none"
      >
        &ldquo;
      </span>

      <p className="text-dark-blue/70 mb-5 text-sm leading-relaxed">{description}</p>

      <div className="border-dark-blue/[0.07] border-t pt-4">
        <p className="font-roboto-medium text-midnight-blue text-sm">{client}</p>
        <p className="text-dark-blue/40 text-xs">{cabinet}</p>
      </div>
    </article>
  );
}
